import { createHttpEndpoint } from '../../utils'

import type { GetMerchantConfiguration } from './merchant-configuration.types'

/**
 * Retrieves Merchant Configuration
 *
 */
export const getMerchantConfiguration =
  createHttpEndpoint<GetMerchantConfiguration>({
    method: 'GET',
    operationId: 'getMerchantPreferences',
    path: '/api/seller-experience/pricing-rules/seller-configurations',
  })

/**
 * Update Merchant Configuration
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Merchant-Configuration/operation/patch-bm-merchants-tools-merchant-configuration}
 */
export const patchMerchantConfiguration = createHttpEndpoint({
  method: 'PATCH',
  operationId: 'updateMerchantPreferences',
  path: '/api/seller-experience/pricing-rules/seller-configurations',
})
